export default __webpack_public_path__ + "6e2747dfe5ae425105d5ed62c5c70a34.svg";